import {
  UserIcon,
  DocumentsIcon,
  ShieldCheckIcon,
  EvaluationIcon,
  UserPlusIcon,
  MedicalNotesIcon,
  PillIcon,
} from "../../Icons";

/**
 * Canonical Patient chart tabs. Keys must match backend `PatientTabKey`
 * / `tenant_patient_tabs.tab_key`.
 */
export const PATIENT_TAB_KEYS = [
  "demographics",
  "assessment",
  "medication",
  "documents",
  "auth",
  "eval",
  "staff",
];

export const PATIENT_TABS = [
  { id: "demographics", label: "Demographics", icon: UserIcon },
  { id: "assessment", label: "Assessment", icon: MedicalNotesIcon },
  { id: "medication", label: "Medication", icon: PillIcon },
  { id: "documents", label: "Documents", icon: DocumentsIcon },
  { id: "auth", label: "Auth & Schedule", icon: ShieldCheckIcon },
  { id: "eval", label: "Eval & Orders", icon: EvaluationIcon },
  { id: "staff", label: "Staff Assignment", icon: UserPlusIcon },
];

export const DEFAULT_ENABLED_TAB_KEYS = [...PATIENT_TAB_KEYS];

export const isPatientTabKey = (value) =>
  typeof value === "string" && PATIENT_TAB_KEYS.includes(value);

/** Prefer demographics when enabled; otherwise first visible tab. */
export function pickDefaultTab(enabledKeys) {
  const keys = Array.isArray(enabledKeys) ? enabledKeys : [];
  if (keys.includes("demographics")) return "demographics";
  return keys[0] || null;
}

export function filterVisibleTabs(enabledKeys) {
  const set = new Set(
    Array.isArray(enabledKeys) && enabledKeys.length
      ? enabledKeys
      : DEFAULT_ENABLED_TAB_KEYS,
  );
  return PATIENT_TABS.filter((t) => set.has(t.id));
}

/** Responsive grid columns based on how many tabs are visible. */
export function tabNavGridClass(count) {
  if (count <= 1) return "grid grid-cols-1 w-full border-b border-slate-200 bg-slate-50 shrink-0";
  if (count === 2) return "grid grid-cols-2 w-full border-b border-slate-200 bg-slate-50 shrink-0";
  if (count === 3)
    return "grid grid-cols-2 sm:grid-cols-3 w-full border-b border-slate-200 bg-slate-50 shrink-0";
  if (count === 4)
    return "grid grid-cols-2 sm:grid-cols-4 w-full border-b border-slate-200 bg-slate-50 shrink-0";
  if (count === 5)
    return "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 w-full border-b border-slate-200 bg-slate-50 shrink-0";
  if (count === 6)
    return "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 w-full border-b border-slate-200 bg-slate-50 shrink-0";
  return "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 w-full border-b border-slate-200 bg-slate-50 shrink-0";
}
